// extracted by mini-css-extract-plugin
export default {"wrapperChart":"ChartWrapper_wrapperChart__5uvPz","swiper":"ChartWrapper_swiper__G+QgK","mb":"ChartWrapper_mb__pNecg"};